<template>
    <v-container class="app-page-container">
        <div v-if="getStudentGroupsChanged">{{ changeGroups() }}</div>
        <GroupList :course_id="$route.params.course_id" />
        <div v-if="!prepared"> ... reading ... </div>
        <DataTable v-if="prepared" :headers="headers" :items="myStudents" :col_hide="1"
                :col_link = "4"
                :row_address = "'student_detail'"
                :row_address_parameter_name = "'student_id'"

                :header_address = "'teacher_task_detail'"
                :header_address_parameter_name = "'task_id'"
                :header_parameters_list = "{'course_id' : $route.params.course_id, 'chapter_id': $route.params.chapter_id, 'lesson_id' : $route.params.lesson_id }"

                :cell_address = "'student_chapter'"
                :cell_address_parameter_row = "'student_id'"
                :cell_address_parameter_column = "'chapter_id'"
        /> 
    </v-container>
</template>

<script>
 import axios from '../axios-auth'
 import { mapGetters } from 'vuex'
 import DataTable from '../components/data/data_table.vue'
 import GroupList from '../components/data/group_list.vue'
 import * as icn from '../assets/task_icons.js'

export default {
    data() {
        return {
            students: [],
            tasks: [],
            headers: [],
            myStudents: [],
            groups_ids: [],
            prepared: false
        }
    },
    computed:
        mapGetters([
            'isDarkMode',
            'getStudentGroupsChanged'
        ])
    ,    
    components: {
        DataTable,
        GroupList       
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            // all students lessons
            let _data = {
                course_id: this.$route.params.course_id,
                chapter_id: this.$route.params.chapter_id,
                lesson_id: this.$route.params.lesson_id
            }
            axios.post('/get-students-groups-tasks', _data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.tasks = res.data.tasks
                    this.students = res.data.students

                    this.refreshGroups()
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 
        },
        changeGroups() {
            this.$store.commit('setStudentGroupsChanged', false)
            const _localg = localStorage.getItem('student_groups')
            if (_localg) this.groups_ids = JSON.parse(_localg)
                else this.groups_ids = []            
            this.refreshGroups()
        },
        refreshGroups() {
            this.prepared = false
            this.headers = []
            this.headers.push({ text: "id", value: 0, width: 0 })
            this.headers.push({ text: "surname", value: 0, width: 60 })
            this.headers.push({ text: "name", value: 0, width: 80 })
            var st = 0
            var svpl = 0
            for (let i = 0; i < this.tasks.length; i++) {
                this.headers.push({                    
                    text: '(' + (this.tasks[i].max_score) + ')',
                    icon: icn.getTaskIcon(this.tasks[i].task_type_id),
                    value: this.tasks[i].id,
                    width: this.defaultWidth
                })
                if (this.tasks[i].task_type == "P") svpl += parseInt(this.tasks[i].max_score)
                if (this.tasks[i].task_type == "T") st += parseInt(this.tasks[i].max_score)
            }            
            svpl = isNaN(svpl) ? 0 : svpl
            st = isNaN(st) ? 0 : st
            this.headers.splice(3, 0, { text: "% ", value: "perc", width: this.defaultWidth })
            this.headers.splice(3, 0, { text: "score (" + st + "/" + svpl + ")", value: "0", width: this.defaultWidth })
            this.headers.splice(3, 0, { text: "score (" + (st + svpl) + ")", value: "0", width: this.defaultWidth})
            this.myStudents = []
            for (let i = 0; i < this.students.length; i++) {
                if (this.groups_ids.indexOf(this.students[i].group_id) > -1) {
                    var tmp = []
                    tmp.push(this.students[i].id)
                    tmp.push(this.students[i].name)
                    tmp.push(this.students[i].surname)
                    tmp.push('')
                    tmp.push('')
                    tmp.push('')
                    var t = 0
                    var vpl = 0
                    var sc = 0
                    for (let j = 0; j < this.students[i].tasks.length; j++) {
                        sc = 0
                        sc = this.students[i].tasks[j].score_tasks + this.students[i].tasks[j].score_programs
                        tmp.push(sc)
                        t += parseInt(this.students[i].tasks[j].score_tasks)
                        vpl += parseInt(this.students[i].tasks[j].score_programs)
                    }
                    tmp[3] = t + vpl
                    tmp[4] = t + '/' + vpl
                    tmp[5] = this.getPerc(t / st) + "/" + this.getPerc(vpl / svpl) + '%'
                   this.myStudents.push(tmp)
                }
            }
            this.prepared = true         
        },
        getPerc(y) {            
            const x = Math.round(y * 1000) / 10
            var perc = ''
            if (x < 10) perc = '0' + x
            else perc = perc + x
            if (perc.indexOf('.') < 0 && (x < 100)) perc = perc + '.0'
            return perc
        },

    }
}
</script>
